import { createContext, useContext } from 'react';

export const BusinessWorkspaceContext = createContext(null);
export const workspaceFromPath = path => /^\/workspace\/([a-f\d]{24})(?:\/|$)/i.exec(path || '')?.[1] || null;
export const workspacePath = id => `/workspace/${encodeURIComponent(id)}`;
export const businessChatPath = (id, chatId) => `${workspacePath(id)}/c/${encodeURIComponent(chatId)}`;
export const businessWorkPath = (id, taskId) => `${workspacePath(id)}/work${taskId ? `/${encodeURIComponent(taskId)}` : ''}`;
export const businessHistoryPath = (id, chat) => chat.coworkerSession ? businessWorkPath(id, chat.coworkerSession) : businessChatPath(id, chat.id);
export const useBusinessWorkspace = () => useContext(BusinessWorkspaceContext);
